<template>
  <div class="q-pa-md text-center">
    <q-spinner size="50px" color="primary" />
    <div class="q-mt-md">Обработка авторизации Facebook...</div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
  // Получаем параметры из URL
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')
  const error = urlParams.get('error')

  if (error) {
    // Отправляем ошибку в родительское окно
    if (window.opener) {
      window.opener.postMessage({
        type: 'FACEBOOK_AUTH_ERROR',
        error: error
      }, window.location.origin)
    }
    window.close()
  } else if (code) {
    // Обмениваем код на токен через API
    exchangeCodeForToken(code)
  } else {
    // Нет кода - ошибка
    if (window.opener) {
      window.opener.postMessage({
        type: 'FACEBOOK_AUTH_ERROR',
        error: 'No authorization code received'
      }, window.location.origin)
    }
    window.close()
  }
})

const exchangeCodeForToken = async (code) => {
  try {
    const response = await fetch('/api/facebook-auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      body: JSON.stringify({ code })
    })

    const data = await response.json()

    if (response.ok && data.access_token) {
      // Отправляем токен в родительское окно
      if (window.opener) {
        window.opener.postMessage({
          type: 'FACEBOOK_AUTH_SUCCESS',
          accessToken: data.access_token
        }, window.location.origin)
      }
    } else {
      throw new Error(data.error || 'Failed to get access token')
    }
  } catch (error) {
    console.error('Error exchanging code for token:', error)

    if (window.opener) {
      window.opener.postMessage({
        type: 'FACEBOOK_AUTH_ERROR',
        error: error.message
      }, window.location.origin)
    }
  }

  window.close()
}
</script>